import { router } from "./routing";
import './styles/index.less';
import { RouterProvider } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
const App = () => { return /*#__PURE__*/ _jsx(RouterProvider, { router: router }); };
export default App;
